module.exports = __webpack_public_path__ + "img/course-icon.2a3231ea.svg";